<!-- eslint-disable @libui/deprecated-attributes -->
<template>
  <ux-container
    space-v="md"
    no-padding
    radius-none
  >
    <ux-card-header>
      <ux-text
        tag="p"
        bold
        center
        class="red-header"
        >FILTRER LES SUPPORTS</ux-text
      >
    </ux-card-header>
    <ux-card-body class="search-container">
      <ux-flex nowrap>
        <ux-text
          tag="p"
          center
          class="search-label"
          >CONTRATS*</ux-text
        >
        <ux-input-a11y-select
          v-model="productId"
          w100
          required
        >
          <span slot="label">Selectionner une valeur</span>
          <p slot="error">Merci de choisir une valeur</p>
          <option
            v-for="product in products"
            :key="product.productId"
            :value="product.productId"
          >
            {{ product.productName }}
          </option>
        </ux-input-a11y-select>
      </ux-flex>
      <ux-flex
        v-if="productId !== ''"
        nowrap
      >
        <ux-text
          tag="p"
          center
          class="search-label"
          >ISIN(S)</ux-text
        >
        <VueMultiselect
          v-model="contractIsins"
          :options="getProductIsins()"
          :multiple="true"
          :close-on-select="false"
          placeholder="Sélectionner"
          @update:model-value="onIsinFilterChange"
        >
        </VueMultiselect>
      </ux-flex>
      <ux-flex
        v-if="productId !== ''"
        nowrap
      >
        <ux-text
          tag="p"
          center
          class="search-label"
          >LIBELLÉ</ux-text
        >
        <ux-input-a11y-select
          id="selectLib"
          v-model="contractLib"
          w100
          required
          @change="onLabelFilterChange()"
        >
          <span slot="label">Selectionner une valeur</span>
          <p slot="error">Merci de choisir une valeur</p>
          <option
            v-for="libelle in getProductLibelles()"
            :key="libelle"
            :value="libelle"
          >
            {{ libelle }}
          </option>
        </ux-input-a11y-select>
      </ux-flex>
    </ux-card-body>
    <ux-card-footer>
      <ux-btn
        :disabled="productId == ''"
        center
        @click="search()"
        >Rechercher</ux-btn
      >
    </ux-card-footer>
  </ux-container>

  <ux-loader :loading="loading"></ux-loader>

  <SearchModal
    :open="showModal"
    :isIsinsModal="isIsinsModal"
    @change="onClose()"
    @action-modal="onActionModal($event)"
  ></SearchModal>
</template>

<script lang="ts">
import SearchModal from './SearchModal.vue'
import { defineComponent } from 'vue'
import { store } from '../store/Store'

import type { ActionEvent, Product } from '@/types'
import VueMultiselect from 'vue-multiselect'

export default defineComponent({
  components: {
    SearchModal,
    VueMultiselect,
  },
  data() {
    return {
      productId: '',
      contractIsins: [],
      contractLib: '',
      showModal: false,
      isIsinsModal: false,
      store: store(),
      loading: false,
    }
  },
  computed: {
    selectedProduct() {
      return store().product
    },
    productDocuments() {
      return store().documents
    },
    products() {
      return store().products
    },
  },
  watch: {
    productId: function (id) {
      this.resetSearch()
      this.loading = true
      const product = this.getProductById(id)
      if (!product) {
        this.loading = false
        // message d'erreur
        return
      }
      setTimeout(() => {
        this.store.selectProduct(product).then(() => {
          this.loading = false
        })
      }, 250)
    },
  },
  created() {
    this.store.fetchProducts()
    this.products = this.store.products
  },
  methods: {
    getProductById(id: string) {
      return this.products.find((data: Product) => data.productId == id)
    },
    onIsinFilterChange() {
      this.showModal = this.contractLib !== ''
      this.isIsinsModal = true
    },
    onLabelFilterChange() {
      this.showModal = Object.keys(this.contractIsins).length > 0
      this.isIsinsModal = false
    },
    search() {
      this.loading = true
      const selectedProduct = this.getProductById(this.productId)
      if (!selectedProduct) {
        this.loading = false
        return
      }
      setTimeout(() => {
        this.store.searchProduct(this.contractIsins, this.contractLib).then(() => {
          this.store.showResult()
          this.loading = false
        })
      }, 250)
    },
    getProductLibelles() {
      return this.store.getProductLibelles()
    },
    getProductIsins() {
      return this.store.getProductIsins()
    },
    resetSearch() {
      this.store.hideResult()
      this.contractIsins = []
      this.contractLib = ''
    },
    onClose() {
      this.showModal = false
    },
    onActionModal(event: ActionEvent) {
      if (event.action === 'close') {
        if (this.isIsinsModal) {
          this.contractIsins = []
        } else {
          this.contractLib = ''
        }
      } else {
        if (this.isIsinsModal) {
          this.contractLib = ''
        } else {
          this.contractIsins = []
        }
        this.store.hideResult()
      }
      this.showModal = false
    },
  },
})
</script>
<style scoped>
.red-header {
  background-color: #d42d2e;
  color: white;
  height: 45px;
  line-height: 40px;
}
.search-container {
  padding: 20px;
}

.search-label {
  width: 10%;
  padding-top: 15px;

  .multiselect__tags {
    border: 10px solid black;
  }
}
</style>
